// react
import React, { useState, useRef, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { components } from "react-select";
import AsyncSelect from "react-select/async";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
//components
// Amplify
import { API, Auth } from "aws-amplify";
// import * as customQueries from "./graphql/topbarSearch.queries";
import * as customQueries from "./graphql/topbarSearch.customqueries";
import env from "../helpers/api/env";
import { DropdownButton } from "react-bootstrap";
import { groupByFields } from "../utils";

/*
 * filter options
 */
const formateOptions = (options) => {
  const grouppedData = groupByFields(options, (item) => {
    return [item.type];
  });

  let formattedOptions = [];
  let count = 0;

  for (let i = 0; i < grouppedData.length; i++) {
    for (let j = 0; j < grouppedData[i].length; j++) {
      if (grouppedData[i][j].type === "users" && count === 0) {
        grouppedData[i].splice(j, 0, {
          label: "Users",
          value: "title",
          type: "title",
        });
        count = 1;
      }
      formattedOptions.push(grouppedData[i][j]);
    }
  }
  return formattedOptions;
};

/* custom control */
const Control = ({ children, ...props }) => {
  const { handleClick } = props.selectProps;
  const [icon, setIcon] = useState("mdi mdi-magnify search-icon");
  useEffect(() => {
    const updateStyle = () => {
      if (window.innerWidth < 430) {
        setIcon("");
      } else if (window.innerWidth < 1024) {
        // Beispiel für mobile Geräte
        setIcon("mdi mdi-magnify search-icon");
      }
    };

    window.addEventListener("resize", updateStyle);
    updateStyle();
    return () => window.removeEventListener("resize", updateStyle);
  }, []);

  return (
    <components.Control {...props}>
      <div className="w-100 d-flex justify-content-center align-items-center">
        <div onMouseDown={handleClick} className={icon}>
          {" "}
        </div>

        <span className="w-100">{children} </span>
      </div>
    </components.Control>
  );
};

// SelectedItemQueries

/* custon indicator */
const IndicatorsContainer = (props) => {
  // const { handleClick } = props.selectProps;

  return (
    <div>
      <components.IndicatorsContainer {...props}>
        {/*    <button className="btn btn-primary" onMouseDown={handleClick}>
          Search
        </button> */}
        <div style={{ backgroundColor: "#fff" }}></div>
      </components.IndicatorsContainer>
    </div>
  );
};

const CustomMenuList = (props) => {
  const { options, inputValue, selectedItem } = props.selectProps;
  const currentLanguage = i18n.language;
  const { t } = useTranslation();
  const showCategorySelect = inputValue.startsWith("#");
  const [menulistitem, setMenuListItem] = useState(null);

  const getFilteredItems = () => {
    let filtered = props.selectProps.items.filter((item) => item.permission);
    if (inputValue.length > 1) {
      const search = inputValue.slice(1).toLowerCase();
      filtered = filtered.filter((item) =>
        t(item.name).toLowerCase().includes(search)
      );
    }
    return filtered;
  };

  useEffect(() => {
    if (showCategorySelect) {
      setMenuListItem(
        <div className="dropdown-header noti-title">
          <h5 className="text-overflow mb-2 ">{t("Choose a Category")}</h5>
        </div>
      );
    } else {
      if (selectedItem === "Category") {
        setMenuListItem();
      } else {
        if (currentLanguage === "de") {
          setMenuListItem(
            <div className="dropdown-header noti-title">
              <h5 className="text-overflow mb-2 ">
                Es wurden <span className="text-danger">{options.length}</span>{" "}
                Ergebnisse gefunden
              </h5>
            </div>
          );
        } else {
          setMenuListItem(
            <div className="dropdown-header noti-title">
              <h5 className="text-overflow mb-2 ">
                Found <span className="text-danger">{options.length}</span>{" "}
                results
              </h5>
            </div>
          );
        }
      }
    }
  }, [t, currentLanguage, showCategorySelect, options]);
  return (
    <components.MenuList className="p-0" {...props}>
      {menulistitem}

      {showCategorySelect
        ? getFilteredItems().map((item, index) => (
            <div
              key={index}
              className="dropdown-item d-flex align-items-center"
              onClick={(e) => {
                e.preventDefault();
                props.selectProps.onCategorySelect(item);
              }}
              style={{
                cursor: "pointer",
                backgroundColor:
                  props.selectProps.dropdownIndex === index
                    ? "#f4f6fb"
                    : undefined,
              }}
            >
              <i className={item.icon} style={{ marginRight: "10px" }} />
              <span>{t(item.name)}</span>
            </div>
          ))
        : props.children}

      <div
        style={{
          borderTop: "1px solid #eee",
          fontSize: "12px",
          padding: "10px 24px",
        }}
      >
        <p className="m-0">
          <strong>{t("Tip")}: </strong>
          {t("Press")}{" "}
          <span
            className="border border-secondary-subtle rounded"
            style={{ padding: "2px 4px" }}
          >
            f
          </span>{" "}
          {t("to open the search from anywhere.")} {t("Type ")}{" "}
          <span
            className="border border-secondary-subtle rounded bg-white"
            style={{ padding: "2px 4px" }}
          >
            #
          </span>{" "}
          {t("in the search to specify the category.")}
        </p>
      </div>
    </components.MenuList>
  );
};

const NoOptionsMessage = (props) => {
  const { t } = useTranslation();
  return (
    props.selectProps.selectedItem !== "Category" && (
      <components.NoOptionsMessage className="mb-2" {...props}>
        <span className="custom-css-class">{t("No results")}</span>
      </components.NoOptionsMessage>
    )
  );
};

const MaxLengthInput = (props) => {
  if (window.innerWidth < 430) {
    return <components.Input {...props} maxLength={15} />;
  } else if (window.innerWidth < 800) {
    return <components.Input {...props} maxLength={35} />;
  } else {
    return <components.Input {...props} maxLength={55} />;
  }
};

const TopbarSearch = (props) => {
  const { t } = useTranslation();
  const history = useHistory();
  let currentLanguage = i18n.language.split("-")[0];
  const [style, setStyle] = useState({});
  const [title, setTitle] = useState(t(props.selectedItem));
  const [placeholder, setPlaceholder] = useState(t("Choose a Category"));
  const [show, setShow] = useState(false);
  const [dropdownIndex, setDropdownIndex] = useState(0);
  const [selectedOption, setSelectedOption] = useState(null);
  const [searchInput, setSearchInput] = useState("");
  const [showCategorySelect, setShowCategorySelect] = useState(false);
  const inputRef = useRef(null);
  const { user } = useSelector((state) => ({
    user: state.Auth.user,
  }));

  let currentUser;

  Auth.currentAuthenticatedUser().then((user) => {
    currentUser = user;
  });

  const handleToggle = (isOpen) => {
    setShow(isOpen);
  };

  const handleItemClick = (itemName) => {
    props.setSelectedItem(itemName);
    setShowCategorySelect(false);
    setShow(false);
    setDropdownIndex(0);
    if (inputRef.current) {
      inputRef.current.setValue(null);
      inputRef.current.onMenuOpen?.();
      inputRef.current.focus();
    }
  };

  const handleCategorySelect = (item) => {
    setSearchInput("");
    setDropdownIndex(0);
    setShowCategorySelect(false);
    inputRef.current.setValue(null);
    props.setSelectedItem(item.name);
    setTimeout(() => {
      inputRef.current.focus();
      inputRef.current.onMenuOpen?.();
    }, 0);
  };

  useEffect(() => {
    if (!showCategorySelect) return;
    const getFilteredItems = () => {
      let filtered = props.items.filter((item) => item.permission);
      if (searchInput.startsWith("#") && searchInput.length > 1) {
        const search = searchInput.slice(1).toLowerCase();
        filtered = filtered.filter((item) =>
          t(item.name).toLowerCase().includes(search)
        );
      }
      return filtered;
    };

    const handleDropdownKeyDown = (e) => {
      console.log("handleDropdownKeyDown", e.key);
      const items = getFilteredItems();
      if (items.length === 0) return;
      if (dropdownIndex >= items.length) setDropdownIndex(0);
      if (e.key === "ArrowDown") {
        e.preventDefault();
        setDropdownIndex((prev) => (prev < items.length - 1 ? prev + 1 : 0));
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        setDropdownIndex((prev) => (prev > 0 ? prev - 1 : items.length - 1));
      } else if (e.key === "Enter") {
        if (dropdownIndex >= 0 && dropdownIndex < items.length) {
          e.preventDefault();
          handleCategorySelect(items[dropdownIndex]);
        }
      } else if (e.key === "Escape") {
        setShowCategorySelect(false);
        setDropdownIndex(0);
        setSearchInput("");
        inputRef.current.blur();
      }
    };
    window.addEventListener("keydown", handleDropdownKeyDown);
    return () => {
      window.removeEventListener("keydown", handleDropdownKeyDown);
    };
  }, [showCategorySelect, dropdownIndex, props.items, searchInput, t]);

  useEffect(() => {
    currentLanguage = i18n.language.split("-")[0];
    if (props.selectedItem !== "Category") {
      setPlaceholder(t("Search in ") + t(props.selectedItem));
    } else {
      setPlaceholder(t("Choose a Category"));
    }
  }, [t, placeholder, props.selectedItem]);

  useEffect(() => {
    const updateStyle = () => {
      if (window.innerWidth < 430) {
        // Beispiel für mobile Geräte
        setStyle({
          backgroundColor: "#eeeeee",
          height: "40px",
          borderRadius: "0px 20px 20px 0px",
          fontSize: "13px",
          /*   display: "block", */
        });
        setTitle("");
        if (props.selectedItem === t("Category")) {
          setPlaceholder(t("Choose a Category"));
        } else {
          setPlaceholder(
            <span style={{ fontSize: "13px" /* display: "block" */ }}>
              {t(props.selectedItem)}
            </span>
          );
        }
      } else if (window.innerWidth < 1025) {
        // Beispiel für mobile Geräte
        setStyle({
          backgroundColor: "#eeeeee",
          height: "40px",
          borderRadius: "0px 20px 20px 0px",
          fontSize: "13px",
          display: "block",
        });
        if (props.selectedItem === t("Category")) {
          setPlaceholder(t("Choose a Category"));
        } else {
          setPlaceholder(
            <span style={{ fontSize: "14px" }}>{t(props.selectedItem)}</span>
          );
        }
        setTitle("");
      } else {
        // Standard für Desktop
        setStyle({
          backgroundColor: "#eeeeee",
          height: "46px",
          borderRadius: "0px 20px 20px 0px",
          paddingLeft: "0.3%",
        });
        if (props.selectedItem === t("Category")) {
          setPlaceholder(t("Choose a Category"));
        } else {
          setPlaceholder(t("Search in ") + t(props.selectedItem));
        }
        setTitle(t(props.selectedItem));
      }
    };

    window.addEventListener("resize", updateStyle);
    updateStyle();
    return () => window.removeEventListener("resize", updateStyle);
  }, [props.selectedItem]);

  // Handle keydown events to open the search bar from anywhere
  useEffect(() => {
    const handleKeyDown = (e) => {
      const tag = e.target.tagName.toLowerCase();
      const isTyping =
        tag === "input" || tag === "textarea" || e.target.isContentEditable;
      const isModalOpen = !!document.querySelector(
        ".modal, [data-modal-open='true']"
      );

      if (
        !isTyping &&
        !isModalOpen &&
        !e.ctrlKey &&
        !e.metaKey &&
        e.key.toLowerCase() === "f"
      ) {
        e.preventDefault();
        if (inputRef.current) {
          inputRef.current.focus();
          inputRef.current.onMenuOpen?.();
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleInputChange = (inputValue, { action }) => {
    setSearchInput(inputValue);
    if (inputValue.startsWith("#")) {
      setShowCategorySelect(true);
      setDropdownIndex(0);
    } else {
      setShowCategorySelect(false);
      setDropdownIndex(0);
    }
    return inputValue;
  };

  const handleChange = (selected) => {
    setSelectedOption(selected);
    if (selected !== null) {
      if (props.selectedItem === "Documents") {
        const downloadItem = (item) => {
          if (user.country === "CN") {
            getDocumentAWS({ document: item })
              .then((res) => res.blob())
              .then((blob) => {
                const file = window.URL.createObjectURL(blob);
                window.open(file);
              });
          } else {
            getDocumentAWS({ document: item })
              .then((response) => response.json())
              .then((json) => {
                window.open(json.downloadURL);
              })
              .catch((error) => {
                console.log("error", error);
              });
          }
        };
        downloadItem(selected);
        inputRef.current.blur();
      } else {
        if (selected.link) {
          history.push(selected.link);
        }
        inputRef.current.blur();
      }
    }
  };

  const getDocumentAWS = async ({ document }) => {
    const API_ENDPOINT =
      "https://030gxdth2f.execute-api.eu-central-1.amazonaws.com/default/lineupdashboardApiPresignedUrl-" +
      env;
    const requestOptions = {
      method: "GET",
      headers: {
        Authorization: currentUser.signInUserSession.idToken.jwtToken,
        "Content-Type": "application/json",
      },
    };

    return fetch(
      API_ENDPOINT + "?action=GET&docId=" + document.id,
      requestOptions
    );
  };

  const promiseOptions = (inputValue) =>
    new Promise((resolve) => {
      let options = []; // Ensure options is scoped correctly for each invocation
      let filteredCategories = props.items.filter((item) => item.permission);
      if (inputValue === "#") {
        resolve(
          filteredCategories.map((item) => ({
            label: t(item.name),
            value: item.name,
            name: item.name,
            icon: item.icon,
          }))
        );
      } else if (
        inputValue &&
        inputValue.length > 1 &&
        inputValue.startsWith("#")
      ) {
        const search = inputValue.slice(1).toLowerCase();
        filteredCategories = filteredCategories.filter((item) =>
          t(item.name).toLowerCase().includes(search)
        );
        resolve(
          filteredCategories.map((item) => ({
            label: t(item.name),
            value: item.name,
            name: item.name,
            icon: item.icon,
          }))
        );
        return;
      }
      const capitalLetter = (string) => string.toUpperCase();
      console.log("inputValue", inputValue, props.selectedItem);
      if (
        inputValue !== undefined &&
        inputValue !== "" &&
        !inputValue.startsWith("#")
      ) {
        switch (props.selectedItem) {
          case "Items":
            if (user.permissions.includes("items.read")) {
              console.log("Items", inputValue);
              Promise.all([
                API.graphql({
                  query:
                    customQueries.translationsByCollectionNameByTranslationItemsSearch,
                  variables: {
                    translationSearch: {
                      beginsWith: inputValue.toLowerCase(),
                    },
                    filter: { field: { eq: "title" } },
                    collectionName: "Items",
                  },
                }),
                API.graphql({
                  query: customQueries.itemsByNumber,
                  variables: {
                    baseType: "Item",
                    limit: 10,
                    number: {
                      beginsWith: inputValue,
                    },
                  },
                }),
              ])
                .then((result) => {
                  console.log("result", result);
                  const items = result.flatMap((res) => {
                    if (res.data.itemsByNumber) {
                      return res.data.itemsByNumber.items.map((item) => {
                        return {
                          ...item,
                          translation: item.translations.items.find(
                            (translation) =>
                              translation.languageCode === currentLanguage &&
                              translation.field === "title"
                          )?.translation,
                        };
                      });
                    } else if (
                      res.data.translationsByCollectionNameByTranslationSearch
                    ) {
                      return res.data.translationsByCollectionNameByTranslationSearch.items.map(
                        (item) => {
                          return {
                            ...item.item,
                            translation: item.translation,
                          };
                        }
                      );
                    } else {
                      return [];
                    }
                  });

                  console.log("items", items);
                  /*      const items =
                    result?.data
                      ?.translationsByCollectionNameByTranslationSearch
                      ?.items || []; */

                  const seenIds = new Set();
                  const options = items
                    .filter((item) => {
                      const mainId = item?.itemsHeadID;
                      const variantIds =
                        item?.variant?.length > 0
                          ? item?.translations?.items?.map(
                              (translation) => translation.objectID
                            )
                          : [];

                      const allIds = [mainId, ...variantIds];
                      const uniqueIds = allIds.filter(
                        (id) => id && !seenIds.has(id)
                      );

                      if (uniqueIds.length > 0) {
                        uniqueIds.forEach((id) => seenIds.add(id));
                        return true;
                      }

                      return false;
                    })
                    .map((item) => {
                      const mainId = item?.itemsHeadID;
                      const variantIds =
                        item?.variant?.length > 0
                          ? item?.translations?.items?.map(
                              (translation) => translation.objectID
                            )
                          : [];

                      const hasVariants = variantIds.length > 0;
                      console.log("return", {
                        label:
                          (item.number ? item.number + " - " : "") +
                          t(item.translation),
                        id: mainId,
                        languageCode: item.languageCode,
                        hasVariants: hasVariants,
                        variants: hasVariants ? variantIds[0] : [],
                        value: mainId,
                        link: hasVariants
                          ? `/item/${mainId}?variant=${variantIds[0]}`
                          : `/item/${mainId}`,
                      });
                      return {
                        label:
                          (item.number !== " " ? item.number + " - " : "") +
                          t(item.translation),
                        id: mainId,
                        languageCode: item.languageCode,
                        hasVariants: hasVariants,
                        variants: hasVariants ? variantIds[0] : [],
                        value: mainId,
                        link: hasVariants
                          ? `/item/${mainId}?variant=${variantIds[0]}`
                          : `/item/${mainId}`,
                      };
                    });
                  resolve(options);
                })
                .catch((error) => {
                  console.error("Error loading options:", error);
                  resolve([]); // Return an empty array in case of error
                });
            }
            break;
          case "Deliveries":
            if (user.permissions.includes("deliveries.read")) {
              API.graphql({
                query: customQueries.searchBarGetDeliveriesByPositionNumber,
                variables: {
                  positionNumber: { beginsWith: inputValue },
                  baseType: "Delivery",
                },
              })
                .then((result) => {
                  const items = result.data.deliveriesByPositionNumber.items;

                  options = items.map((item) => {
                    let path = "";
                    switch (item.type) {
                      case "warehouseToCustomer":
                        path = "/goodsIssue/";
                        break;
                      case "harborToWarehouse":
                        path = "/goodsReceipt/";
                        break;
                      case "harborToCustomer":
                        path = "/directDelivery/";
                        break;
                      default:
                        break;
                    }

                    return {
                      id: item.id,
                      number: item.positionNumber,
                      label: item.positionNumber,
                      value: item.id,
                      link: path + item.id,
                    };
                  });
                  resolve(options);
                })
                .catch((error) => {
                  console.error("Error loading options:", error);
                  resolve([]); // Return an empty array in case of error
                });
            }
            break;
          case "Companies":
            if (
              user.permissions.includes("suppliers.read") ||
              user.permissions.includes("customers.read") ||
              user.permissions.includes("companies.read")
            ) {
              Promise.all([
                API.graphql({
                  query: customQueries.companiesByTypeByCompanyNameSearch,
                  variables: {
                    nameSearch: { beginsWith: inputValue.toLowerCase() },
                    type: "supplier",
                  },
                }),
                API.graphql({
                  query: customQueries.companiesByTypeByCompanyNameSearch,
                  variables: {
                    nameSearch: { beginsWith: inputValue.toLowerCase() },
                    type: "customer",
                  },
                }),
                API.graphql({
                  query: customQueries.companiesByCompanyNumber,
                  variables: {
                    number: { beginsWith: inputValue },
                    baseType: "Company",
                  },
                }),
                /*   API.graphql({
                  query: customQueries.usersByEmail,
                  variables: {
                    email: { beginsWith: inputValue },
                    baseType: "Company",
                  },
                }), */
              ]).then((result) => {
                const items = result.flatMap((res) => {
                  const itemsField = Object.values(res.data).find(
                    (val) => val && Array.isArray(val.items)
                  );
                  return itemsField ? itemsField.items : [];
                });

                const options = items.map((item) => ({
                  label: item.name + " - " + item.number,
                  id: item.id,
                  number: item.number,
                  type: item.type,
                  value: item.id,
                  link: `/${item.type}/${item.id}`,
                }));
                resolve(options);
              });
            }
            break;
          case "Orders":
            if (user.permissions.includes("orders.read")) {
              API.graphql({
                query: customQueries.searchBarGetOrdersByOrderNumber,
                variables: {
                  orderNumber: { beginsWith: inputValue },
                  baseType: "Order",
                },
              })
                .then((result) => {
                  const items = result.data.ordersByOrderNumber.items;
                  options = items.map((item) => ({
                    id: item.id,
                    number: item.orderNumber + "/" + item.customerReference,
                    label: item.orderNumber + "/" + item.customerReference,
                    value: item.id,
                    link: `/order/${item.id}`,
                  }));

                  if (options.length === 0) {
                    return API.graphql({
                      query:
                        customQueries.searchBarGetOrdersByCustomerReference,
                      variables: {
                        customerReference: { beginsWith: inputValue },
                        baseType: "Order",
                      },
                    });
                  } else {
                    resolve(options);
                    return null;
                  }
                })
                .then((result) => {
                  if (result) {
                    const items = result.data.ordersByCustomerReference.items;
                    options = items.map((item) => ({
                      label: item.customerReference + "/" + item.orderNumber,
                      value: item.orderNumber,
                      id: item.id,
                      number: item.orderNumber,
                      link: `/order/${item.id}`,
                    }));
                  }
                  resolve(options);
                })
                .catch((error) => {
                  console.error("Error loading options:", error);
                  resolve([]); // Return an empty array in case of error
                });
            }
            break;
          case "Purchase Orders":
            if (user.permissions.includes("purchaseOrders.read")) {
              API.graphql({
                query:
                  customQueries.searchBarGetPurchaseOrdersByPurchaseOrderNumber,
                variables: {
                  purchaseOrderNumber: { beginsWith: inputValue },
                  baseType: "Order",
                },
              })
                .then((result) => {
                  const items =
                    result.data.purchaseOrdersByPurchaseOrderNumber.items;
                  options = items.map((item) => ({
                    id: item.id,
                    number: item.purchaseOrderNumber,
                    label: item.purchaseOrderNumber,
                    value: item.id,
                    link: `/purchaseOrder/${item.id}`,
                  }));

                  if (options.length === 0) {
                    return API.graphql({
                      query:
                        customQueries.searchBarGetPurchaseOrdersBySapReference,
                      variables: {
                        sapReference: { beginsWith: inputValue },
                        baseType: "PurchaseOrder",
                      },
                    });
                  } else {
                    resolve(options);
                    return null;
                  }
                })
                .then((result) => {
                  if (result) {
                    const items =
                      result.data.purchaseOrdersBySapReference.items;
                    options = items.map((item) => ({
                      label: "Purchase Order",
                      id: item.id,
                      number: item.purchaseOrderNumber,
                      label: item.purchaseOrderNumber,
                      value: item.id,
                      link: `/purchaseOrder/${item.id}`,
                    }));
                  }
                  resolve(options);
                })
                .catch((error) => {
                  console.error("Error loading options:", error);
                  resolve([]); // Return an empty array in case of error
                });
            }
            break;
          case "Product Requests":
            if (user.permissions.includes("productRequests.read")) {
              let searchfunction = [];
              searchfunction.push(
                API.graphql({
                  query:
                    customQueries.translationsByCollectionNameByTranslationItemsSearch,
                  variables: {
                    collectionName: "Productrequests",
                    translationSearch: { beginsWith: inputValue.toLowerCase() },
                  },
                })
              );
              searchfunction.push(
                API.graphql({
                  query:
                    customQueries.searchBarGetProductRequestByPositionNumber,
                  variables: {
                    positionNumber: { beginsWith: inputValue },
                    baseType: "ProductRequest",
                  },
                })
              );

              Promise.all(searchfunction)
                .then((result) => {
                  const [translationsResult, positionNumberResult] = result;

                  const translationSearch =
                    translationsResult?.data
                      ?.translationsByCollectionNameByTranslationSearch
                      ?.items || [];
                  const positionNumberSearch =
                    positionNumberResult?.data?.productRequestsByPositionNumber
                      ?.items || [];

                  const filteredItems = [
                    ...translationSearch,
                    ...positionNumberSearch,
                  ];

                  const uniqueItems = {};
                  filteredItems.forEach((item) => {
                    const id = item?.objectID || item?.id;
                    if (id && !uniqueItems[id]) {
                      uniqueItems[id] = item;
                    }
                  });

                  const finalItems = Object.values(uniqueItems);

                  options = finalItems.map((item) => {
                    const label =
                      item?.translation ||
                      item?.translations?.items?.find(
                        (translation) =>
                          translation.languageCode === currentLanguage
                      )?.translation;
                    const number =
                      item?.positionNumber ||
                      item?.productRequest?.positionNumber;

                    const id = item?.objectID || item?.id;

                    return {
                      id: id,
                      number: number,
                      title: label,
                      label: number + " - " + label,
                      value: id,
                      link: `/productRequest/${id}`,
                    };
                  });
                  resolve(options);
                })
                .catch((error) => {
                  console.error("Error loading options:", error);
                  resolve([]); // Return an empty array in case of error
                });
            }
            break;
          case "Seafreight":
            if (user.permissions.includes("shipments.read")) {
              Promise.all([
                API.graphql({
                  query: customQueries.searchBarGetShipmentsByPositionNumber,
                  variables: {
                    positionNumber: {
                      beginsWith: capitalLetter(inputValue),
                    },
                    baseType: "SeaFreight",
                  },
                }),
                API.graphql({
                  query: customQueries.shipmentsByTrackingCode,
                  variables: {
                    baseType: "SeaFreight",
                    trackingCode: {
                      beginsWith: capitalLetter(inputValue),
                    },
                  },
                }),
              ])
                .then((result) => {
                  const items = result.flatMap((res) => {
                    if (res.data.shipmentsByPositionNumber) {
                      return res.data.shipmentsByPositionNumber.items;
                    } else if (res.data.shipmentsByTrackingCode) {
                      return res.data.shipmentsByTrackingCode.items;
                    } else {
                      return [];
                    }
                  });

                  options = items.map((item) => ({
                    id: item.id,
                    number: item.positionNumber,
                    label: item.positionNumber,
                    value: item.id,
                    link: `/shipment/${item.id}`,
                  }));
                  resolve(options);
                })
                .catch((error) => {
                  console.error("Error loading options:", error);
                  resolve([]); // Return an empty array in case of error
                });
            }
            break;
          case "Customs":
            if (user.permissions.includes("customs.read")) {
              API.graphql({
                query: customQueries.searchBarGetCustomsByPositionNumber,
                variables: {
                  number: { beginsWith: capitalLetter(inputValue) },
                  baseType: "Customs",
                },
              })
                .then((result) => {
                  const items = result.data.customsByPositionNumber.items;
                  options = items.map((item) => ({
                    id: item.id,
                    number: item.positionNumber,
                    label: item.positionNumber,
                    value: item.id,
                    link: `/customs/${item.id}`,
                  }));
                  resolve(options);
                })
                .catch((error) => {
                  console.error("Error loading options:", error);
                  resolve([]); // Return an empty array in case of error
                });
            }
            break;
          case "Air Freight":
            if (user.permissions.includes("shipments.read")) {
              API.graphql({
                query:
                  customQueries.searchBarGetShipmentsByPositionNumberAirfreight,
                variables: {
                  positionNumber: {
                    beginsWith: capitalLetter(inputValue),
                  },
                  baseType: "AirFreight",
                },
              })
                .then((result) => {
                  const items = result.data.shipmentsByPositionNumber.items;
                  options = items.map((item) => ({
                    id: item.id,
                    number: item.positionNumber,
                    label: item.positionNumber,
                    value: item.id,
                    link: `/airFreight/${item.id}`,
                  }));
                  resolve(options);
                })
                .catch((error) => {
                  console.error("Error loading options:", error);
                  resolve([]); // Return an empty array in case of error
                });
            }
            break;
          case "Documents":
            if (
              user.permissions.includes("document.items.read") &&
              user.permissions.includes("document.orders.read")
            ) {
              API.graphql({
                query: customQueries.listDocuments,
                variables: {
                  filter: { name: { beginsWith: capitalLetter(inputValue) } },
                },
              })
                .then((result) => {
                  const items = result.data.listDocuments.items;
                  options = items.map((item) => ({
                    label: item.name,
                    id: item.id,
                    number: item.collectionName,
                    collectionName: item.collectionName,
                    objectID: item.objectID,
                    value: item.id,
                    link: `/document/${item.id}`,
                  }));
                  resolve(options);
                })
                .catch((error) => {
                  console.error("Error loading options:", error);
                  resolve([]); // Return an empty array in case of error
                });
            }
            break;
          case "Requests":
            console.log("Requests", inputValue);
            if (user.permissions.includes("customerRequests.read")) {
              console.log("Requests has permission");
              Promise.all([
                API.graphql({
                  query: customQueries.customerRequestsByNumber,
                  variables: {
                    baseType: "CustomerRequest",
                    number: { beginsWith: inputValue.toUpperCase() },
                  },
                }),
                API.graphql({
                  query: customQueries.customerRequestsByReference,
                  variables: {
                    baseType: "CustomerRequest",
                    reference: { beginsWith: inputValue },
                  },
                }),
                API.graphql({
                  query: customQueries.customerRequestItemsByTitle,
                  variables: {
                    baseType: "CustomerRequestItem",
                    title: { beginsWith: inputValue },
                  },
                }),
                API.graphql({
                  query:
                    customQueries.customerRequestItemsByCustomerArticleNumber,
                  variables: {
                    baseType: "CustomerRequestItem",
                    customerArticleNumber: { beginsWith: inputValue },
                  },
                }),
              ])
                .then((result) => {
                  console.log("Requests result", result);

                  const items = result.flatMap((res) => {
                    if (res.data.customerRequestsByNumber) {
                      return res.data.customerRequestsByNumber.items;
                    } else if (res.data.customerRequestsByReference) {
                      return res.data.customerRequestsByReference.items;
                    } else if (res.data.customerRequestItemsByTitle) {
                      return res.data.customerRequestItemsByTitle.items.map(
                        (item) => {
                          return {
                            ...item.customerRequest,
                            additionalLabel:
                              " - " +
                              item.customerArticleNumber +
                              " - " +
                              item.title,
                          };
                        }
                      );
                    } else if (
                      res.data.customerRequestItemsByCustomerArticleNumber
                    ) {
                      return res.data.customerRequestItemsByCustomerArticleNumber.items.map(
                        (item) => {
                          return {
                            ...item.customerRequest,
                            additionalLabel:
                              " - " +
                              item.customerArticleNumber +
                              " - " +
                              item.title,
                          };
                        }
                      );
                    }
                  });
                  console.log("Requests items", items);
                  options = items.map((item) => ({
                    label:
                      item.number +
                      " - " +
                      (item.reference ? item.reference + " - " : "") +
                      item.company.name +
                      (item.additionalLabel ? item.additionalLabel : ""),
                    id: item.id,
                    number: item.number,
                    customerRequestsID: item.id,
                    value: item.id,
                    link: `/request/edit/${item.id}`,
                  }));
                  resolve(options);
                })
                .catch((error) => {
                  console.error("Error loading options:", error);
                  resolve([]); // Return an empty array in case of error
                });
            }
            break;
          default:
            resolve([]); // Ensure to resolve the promise in all cases
        }
      }
    });

  return (
    <>
      <div className="m-auto w-50">
        <div className="dropdown d-flex align-items-center app" style={style}>
          <DropdownButton
            size="sm"
            title={t(title)}
            variant="secondary"
            show={show}
            onToggle={handleToggle}
            onClick={(e) => e.stopPropagation()}
            style={{
              display: "flex",
              float: "left",
              alignItems: "center",
              position: "relative",
              zIndex: "100",
              left: "0.3%",
              paddingRight: "2%",
              borderRadius: "20px 0px 0px 20px",
              border: "none",
            }}
          >
            {props.items.map(
              (item, index) =>
                item.permission && (
                  <li
                    className="dropdown-item"
                    key={index}
                    active={props.selected === item.name}
                    onClick={() => handleItemClick(item.name)}
                    style={{
                      fontSize: "14px",
                      overflow: "hidden",
                      display: "flex",
                      alignItems: "center",
                      height: "40px",
                      cursor: "pointer",
                    }}
                  >
                    <i
                      className={item.icon}
                      style={{
                        fontSize: "18px",
                        marginRight: "4%",
                        display: "inline-flex",
                        alignItems: "center",
                      }}
                    ></i>
                    <span style={{ marginTop: "2%", marginBottom: "2%" }}>
                      {t(item.name)}
                    </span>
                  </li>
                )
            )}
            <div
              style={{
                fontSize: "12px",
                backgroundColor: "#f9fafb",
                padding: "10px 24px",
              }}
            >
              <p className="m-0">
                {t("Type ")}{" "}
                <span
                  className="border border-secondary-subtle rounded bg-white"
                  style={{ padding: "2px 4px" }}
                >
                  #
                </span>{" "}
                {t("in the search to specify the category.")}
              </p>
            </div>
          </DropdownButton>

          {/* New AsyncSelect  */}
          <div className="w-100">
            <AsyncSelect
              {...props}
              components={{
                Control,
                IndicatorsContainer,
                NoOptionsMessage,
                MenuList: CustomMenuList,
                Input: MaxLengthInput,
              }}
              onCategorySelect={handleCategorySelect}
              dropdownIndex={dropdownIndex}
              closeMenuOnSelect={false}
              items={props.items}
              placeholder={placeholder}
              value={selectedOption}
              onChange={handleChange}
              loadOptions={promiseOptions}
              onInputChange={handleInputChange}
              inputValue={searchInput}
              maxMenuHeight="350px"
              ref={inputRef}
              selectedItem={props.selectedItem}
              className="w-100 position-relative z-80"
              classNamePrefix="react-select"
              name="search-app"
              styles={{
                control: (provided) => ({
                  ...provided,
                  border: "none",
                  backgroundColor: "transparent",
                  boxShadow: "none",
                  overflow: "hidden",
                }),
                placeholder: (provided) => ({
                  ...provided,
                  pointerEvents: "none",
                  userSelect: "none",
                  MozUserSelect: "none",
                  WebkitUserSelect: "none",
                  msUserSelect: "none",
                  border: "none",
                  overflow: "hidden",
                  position: "static !important",
                }),
                input: (provided) => ({
                  ...provided,
                  input: {
                    gridArea: "1 / 2 / 4 / 4 !important",
                  },
                }),
                menuList: (provided) =>
                  showCategorySelect
                    ? {
                        ...provided,
                        maxHeight: "100%",
                        height: "100%",
                        maxWidth: "100%",
                      }
                    : provided,
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default TopbarSearch;

// BACKUP

// switch (doc._key.path.segments[5]) {
//   case "deliveries":
//     searchResult = {
//       label: t("Delivery") + ": " + result.delivery_position_number,
//       icon: "uil-truck",
//       type: "delivery",
//       id: doc.id,
//     };
//     break;

//   case "purchase_orders":

//     break;
//   default:
// }

// options.push(searchResult);
